import useMutationApi from 'src/api/useMutationApi';

export interface DisableModuleData {
  entityType: string;
  entityId: string;
  moduleName: string;
}

export interface DisableModuleResponse {
  success: boolean;
  message: string;
}

const useDisableModule = (onSuccess?: () => void) => {
  return useMutationApi<DisableModuleData, DisableModuleResponse>({
    endpoint: 'core/modules/disable',
    method: 'POST',
    successMessage: 'Module disabled successfully',
    errorMessage: 'Failed to disable module',
    options: {
      onSuccess,
    },
  });
};

export default useDisableModule;
